import { render, staticRenderFns } from "./DeviceDetailBackup.vue?vue&type=template&id=618578b2&scoped=true&"
import script from "./DeviceDetailBackup.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailBackup.vue?vue&type=script&lang=js&"
import style0 from "./DeviceDetailBackup.vue?vue&type=style&index=0&id=618578b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618578b2",
  null
  
)

export default component.exports